var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSelected = function SvgSelected(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M10 20C4.524 20 0 15.476 0 10S4.516 0 9.992 0 20 4.524 20 10s-4.524 10-10 10m-1.229-4.977c.284 0 .53-.13.714-.415l5.162-8.087c.115-.17.215-.377.215-.561 0-.407-.361-.66-.738-.66-.222 0-.445.13-.614.391l-4.777 7.596L6.19 10.1c-.2-.254-.407-.346-.652-.346-.377 0-.692.3-.692.707 0 .192.077.4.208.56l2.964 3.595c.239.292.469.407.753.407",
    clipRule: "evenodd"
  })));
};
export default SvgSelected;